import { createFileRoute } from "@tanstack/react-router";
import { GarageModules } from "@/features/settings/modules";

export const Route = createFileRoute("/settings/modules")({
  component: GarageModules,
});
